/* eslint-disable quotes */
/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/no-unresolved
import introJs from "intro.js";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { translate } from "../../../../../providers";
import { isNonEmptyArray } from "../../../../../utils";
import { isElementPlaced } from "../../../utils/utils";

const ReviewReaderTour = ({ activatedTour, currentTour, onClose, onCompleteTour }) => {
	const reviewContent = useSelector(({ srPdf }) => srPdf.content);
	const introRef = useRef(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const handleSetUpDisplay = () => {
		const targetBtn = document.querySelector('button svg[data-icon="bars"]')?.closest("button");
		if (targetBtn) {
			targetBtn.click();
		}
		const button = document.querySelector(
			'div[class^="VerticalNavbar_container__menus__"] > span:first-of-type > button'
		);

		if (button) {
			button.click();
		}
	};
	if (!introRef?.current) {
		introRef.current = introJs();
	}
	useEffect(() => {
		let elapsed = 0;
		let fallbackMode = false;
		const checkInterval = 200;
		const fallbackDelay = 3000;
		const reviewMenuButton = Array.from(document.querySelectorAll("button")).find((btn) => {
			const span = btn.querySelector("span");
			return span && span.textContent.trim() === translate("navigation:project.review");
		});
		introRef.current.setOptions({
			disableInteraction: true,
			nextLabel: translate("common:btn.next"),
			prevLabel: translate("common:btn.previous"),
			doneLabel: translate("common:btn.finish"),
			exitOnEsc: false,
			exitOnOverlayClick: false,
			hidePrev: true,
			keyboardNavigation: false,
			helperElementPadding: 8,
			steps: [
				{
					step: 0,
					title: translate("common:product-tour.essential.review.step.1.title"),
					intro: translate("common:product-tour.essential.review.step.1.intro"),
					element: reviewMenuButton,
					position: "bottom",
				},
				{
					step: 1,
					title: translate("common:product-tour.essential.review.step.2.title"),
					intro: translate("common:product-tour.essential.review.step.2.intro"),
					element: "#tour-review-document-list",
					position: "right",
				},
				{
					step: 2,
					title: translate("common:product-tour.essential.review.step.3.title"),
					intro: translate("common:product-tour.essential.review.step.3.intro"),
					element: "div[class^='PdfHeader_container__']",
				},
				{
					step: 3,
					title: translate("common:product-tour.essential.review.step.4.title"),
					intro: translate("common:product-tour.essential.review.step.4.intro"),
					element: "div[class^='FiltersWrapper_innerWrapper__",
				},
				{
					step: 4,
					title: translate("common:product-tour.essential.review.step.5.title"),
					intro: translate("common:product-tour.essential.review.step.5.intro"),
					element: "#tourRightPanelOverlay",
					position: "left",
				},
				{
					step: 5,
					title: translate("common:product-tour.essential.review.step.6.title"),
					intro: translate("common:product-tour.essential.review.step.6.intro"),
					element: `span[class^='CustomIconButton_wrapper__'][aria-label=${translate(
						"smart-review.cmp-details.option-panel.comments"
					)}] > button`,
					position: "left",
				},
				{
					step: 6,
					title: translate("common:product-tour.essential.review.step.7.title"),
					intro: translate("common:product-tour.essential.review.step.7.intro"),
					element: "div[class^='VerticalNavbar_container__menus__'] > span:last-of-type > button",
					position: "left",
				},
			],
			tooltipClass: "IntroJsClass",
			showBullets: false,
			showProgress: false,
			showStepNumbers: false,
		});
		introRef.current.onbeforechange(() => {
			if (introRef.current) {
				setTimeout(() => introRef.current.refresh(), 100);
			}
		});
		introRef.current.onafterchange(() => {
			const currentStepIndex = introRef.current._currentStep;
			const totalSteps = introRef.current._options.steps.length;
			const tooltipButtons = document.querySelector(".introjs-tooltipbuttons");
			if (!tooltipButtons) {
				return;
			}
			const existingCounter = tooltipButtons.querySelector(".custom-step-counter");
			if (existingCounter) {
				existingCounter.remove();
			}
			const counter = document.createElement("div");
			counter.className = "custom-step-counter";
			counter.textContent = translate("common:product-tour.steps", {
				current: currentStepIndex + 1,
				total: totalSteps,
			});
			tooltipButtons.insertBefore(counter, tooltipButtons.firstChild);
		});
		const handleExit = () => {
			onClose(currentTour);
			introRef.current = null;
		};
		introRef.current.onexit(() => {
			handleExit();
		});
		introRef.current.oncomplete((_, reason) => {
			if (reason === "done") {
				onCompleteTour(currentTour);
			}
			handleExit();
		});
		const intervalId = setInterval(() => {
			elapsed += checkInterval;
			const targetDiv = document.getElementById("tour-review-pdf-viewer");
			const targetPdfDiv = document.querySelector("div[class^='PdfViewer_pdfViewerList__']");
			const hasLoaded = isNonEmptyArray(reviewContent) && reviewContent.every((page) => !page.isLoading);
			if (!fallbackMode && elapsed < fallbackDelay) {
				if (isElementPlaced(targetDiv) && hasLoaded && activatedTour === currentTour.id) {
					clearInterval(intervalId);
					handleSetUpDisplay();
					setTimeout(() => introRef.current?.start(), 1000);
					return;
				}
				return;
			}
			if (!fallbackMode && elapsed >= fallbackDelay) {
				fallbackMode = true;
			}
			if (fallbackMode) {
				if (isElementPlaced(targetDiv) && isElementPlaced(targetPdfDiv) && activatedTour === currentTour.id) {
					clearInterval(intervalId);
					handleSetUpDisplay();
					setTimeout(() => {
						introRef.current?.start();
					}, [300]);
				}
			}
		}, checkInterval);
		return () => {
			clearInterval(intervalId);
		};
	}, [navigate, dispatch, onClose, onCompleteTour, activatedTour, currentTour, reviewContent]);
	return <></>;
};

export default ReviewReaderTour;
